import "./Match.css";
import Sheet from "@mui/joy/Sheet";
import Stack from "@mui/joy/Stack";
import { styled } from "@mui/joy/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { FaRegWindowClose } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchJobTemplates,
  fetchTemplateFields,
  setSelectedTemplateType,
  setHeaderMapping,
} from "../../state/Match/matchSlice";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const Item = styled(Sheet)(({ theme }) => ({
  ...theme.typography["body-sm"],
  textAlign: "center",
  fontWeight: theme.fontWeight.md,
  color: theme.vars.palette.text.secondary,
  border: "1px solid",
  borderColor: theme.palette.divider,
  padding: theme.spacing(1),
  borderRadius: theme.radius.md,
}));

const MatchNew = ({ clickToClose, initialMappingData }) => {
  const dispatch = useDispatch();
  const [warningMessage, setWarningMessage] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  //const user_token = useSelector((state) => state.login.token);
  const selectedJobId = useSelector((state) => state.fileUpload.selectedJob.id);
  const [openDialog, setOpenDialog] = useState(false);
  const [openMapCheckDialog, setOpenMapCheckDialog] = useState(false);
  const [ambiguousHeader, setAmbiguousHeader] = useState("");
  const [missingFields, setMissingFields] = useState([]);
  const ambiguityArray = ["name"];

  useEffect(() => {
    dispatch(
      fetchJobTemplates({ jobTypeId: selectedJobId})
    );
  }, [ selectedJobId, dispatch]);

  const initialTemplate = useSelector(
    (state) => state.match.selectedTemplateType
  );
  const [selectedTemplate, setSelectedTemplate] = useState({
    id: "",
    templateName: "",
  });

  const templates = useSelector((state) => state.match.templates);

  const handleTemplateChange = (event) => {
    const selectedID = event.target.value;
    const selectedTemp = templates.find((item) => item.id === selectedID);
    if (selectedTemp) {
      setSelectedTemplate(selectedTemp);
    }
  };

  useEffect(() => {
    console.log("Template Selected: ");
    console.log(selectedTemplate);
    dispatch(setSelectedTemplateType(selectedTemplate));
  }, [selectedTemplate, dispatch]);

  const selectedTemplateId = useSelector(
    (state) => state.match.selectedTemplateType.id
  );

  useEffect(() => {
    if (selectedTemplateId !== "") {
      dispatch(
        fetchTemplateFields({
          templateId: selectedTemplateId,
         // token: user_token,
        })
      );
    }
  }, [selectedTemplateId,  dispatch]);

  const DBFields = useSelector((state) => state.match.templateFields);
  const colHeaders = useSelector((state) => state.match.columnHeaders);
  const [columns, setColumns] = useState(colHeaders);
  const [selectedValues, setSelectedValues] = useState([]);

  // Helper function to automatically match DBField and column headers
  const autoMapFields = () => {
    const enhancedAutoMapping = DBFields.map((field) => {
      const normalizedFieldName = field.fieldName
        .toLowerCase()
        .replace(/\s+|_/g, "");

      const matchedColumn = columns.find((column) => {
        const normalizedColumnName = column.toLowerCase().replace(/\s+|_/g, "");

        if (normalizedFieldName === normalizedColumnName) {
          return true;
        }

        if (
          normalizedFieldName.includes(normalizedColumnName) ||
          normalizedColumnName.includes(normalizedFieldName)
        ) {
          return true;
        }

        const synonyms = {
          id: ["identifier", "id"],
          title: ["jobtitle", "title"],
          fullname: ["fullname", "name"],
          firstname: ["firstname", "first", "name"],
          lastname: ["lastname", "last", "surname"],
          phone: ["telephone", "phone"],
          fax: ["fax"],
          address: ["address"],
          address1: ["address1", "addressline1"],
          address2: ["address2", "addressline2"],
          suburb: ["suburb", "city"],
          postcode: ["postcode", "zip"],
          state: ["state", "region"],
          specialty: ["specialty", "specialisation", "field"],
          workplacename: [
            "location",
            "wpname",
            "company",
            "practicename",
            "organization",
            "organisation",
            "workplacename",
          ],
        };

        return Object.entries(synonyms).some(([key, values]) => {
          return (
            values.includes(normalizedFieldName) &&
            values.includes(normalizedColumnName)
          );
        });
      });

      return {
        DBField: field.fieldName,
        Required: field.required,
        Column: matchedColumn || "",
      };
    });
    return enhancedAutoMapping;
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    clickToClose(); // Closing pop-up
  };

  const handleMapCheckDialogClose = () => {
    setOpenMapCheckDialog(false);
  };

  // Check for ambiguous column headers when colHeaders changes
  useEffect(() => {
    const ambiguousMatch = colHeaders.find((header) =>
      ambiguityArray.includes(header.toLowerCase())
    );

    if (ambiguousMatch) {
      setAmbiguousHeader(ambiguousMatch);
      setOpenDialog(true);
    }
  }, [colHeaders]);

  useEffect(() => {
    if (initialTemplate && initialMappingData.length > 0) {
      setSelectedValues(initialMappingData);
      setSelectedTemplate(initialTemplate);
    }
  }, []);

  useEffect(() => {
    if (DBFields.length > 0 && initialMappingData.length == 0) {
      console.log("Auto mapping was invoked");
      const autoMappedValues = autoMapFields(DBFields, colHeaders);
      setSelectedValues(autoMappedValues);
    }
  }, [DBFields, initialMappingData]);

  useEffect(() => {
    const allSelected = selectedValues.every((item) => item.Column !== "");
    const templateSelected = selectedTemplate.templateName !== "";
    const columnsSelected = selectedValues.map((item) => item.Column);
    const duplicates = columnsSelected.filter(
      (item, index) => columnsSelected.indexOf(item) !== index && item !== ""
    );

    const duplicateFields = selectedValues
      .filter((item) => duplicates.includes(item.Column))
      .map((item) => item.DBField);

    if (duplicateFields.length > 0) {
      setWarningMessage(
        `Warning: Duplicate columns selected for fields: ${duplicateFields.join(
          ", "
        )}. `
      );
      setIsFormValid(false);
    } else {
      setWarningMessage("");
      // setIsFormValid(allSelected && templateSelected);
      setIsFormValid(templateSelected);
    }

    console.log("valid", allSelected);
  }, [selectedValues, selectedTemplate]);

  const navigate = useNavigate();

  const handleSelectChange = (field, value, index) => {
    const newValues = selectedValues.map((item) =>
      item.DBField === field ? { ...item, Column: value } : item
    );
    console.log("new values", newValues);
    setSelectedValues(newValues);
  };

  // const getFilteredColumns = (index) => {
  //   const selectedColumns = selectedValues.map((item) => item.Column);
  //   return columns.filter(
  //     (column) =>
  //       !selectedColumns.includes(column) ||
  //       selectedValues[index]?.Column === column
  //   );
  // };

  const handleConfirmClick = () => {
    if (!selectedTemplate.templateName) {
      alert("Please select a file template.");
      return;
    }

    // Check for required fields that are not mapped to columns
    const requiredUnmappedFields = selectedValues.filter(
      (item) => item.Required && (!item.Column || item.Column === "")
    );

    if (requiredUnmappedFields.length > 0) {
      // Store the missing required fields to display in the dialog
      setMissingFields(requiredUnmappedFields.map((field) => field.DBField));
      setOpenMapCheckDialog(true); // Trigger dialog popup
      return;
    }

    // const allSelected = selectedValues.every(
    //   (item) => item.Column !== null && item.Column !== ""
    // );
    // if (!allSelected) {
    //   alert("Please select all dropdown before submitting");
    // }
    dispatch(setHeaderMapping(selectedValues));
    clickToClose();
  };

  const handleSelectReset = () => {
    //setColumns(colHeaders);
    dispatch(setHeaderMapping([]));
  };

  return (
    <>
      <div className="colm-header">
        <h2>COLUMN HEADER MAPPING</h2>
        <span className="close-popup" onClick={clickToClose}>
          <FaRegWindowClose />
        </span>
      </div>
      <div className="container-form">
        <div className="container-main">
          <div className="file-template-details">
            <FormControl>
              <InputLabel id="demo-simple-select-label">
                File Template
              </InputLabel>

              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="File Template"
                value={selectedTemplate.id || ""}
                onChange={handleTemplateChange}
                sx={{
                  width: 350,
                  height: 55,
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#ab1368",
                    },
                    "&:hover fieldset": {
                      borderColor: "#ab1368",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#ab1368",
                    },
                  },
                  "& .MuiSelect-select": {
                    color: "#ab1368",
                  },
                  "& .MuiSelect-icon": {
                    color: "#ab1368",
                  },
                  "& .MuiMenuItem-root.Mui-selected": {
                    color: "#ab1368",
                  },
                }}
                renderValue={(selected) => {
                  const selectedTemplate = templates.find(
                    (item) => item.id === selected
                  );
                  return selectedTemplate ? selectedTemplate.templateName : "";
                }}
              >
                {templates.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.templateName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {selectedTemplate.templateName && (
            <div className="content-box">
              <Box sx={{ flexGrow: 1 }}>
                <Grid container>
                  <Grid item xs={12}>
                    <Item
                      sx={{ backgroundColor: "#dee3eb;", color: "#ab1368;" }}
                    >
                      MATCH THE DATABASE COLUMNS
                    </Item>
                  </Grid>
                </Grid>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Stack
                    spacing={4.5}
                    sx={{
                      width: "65%",
                      marginTop: "30px",
                      align: "center",
                      marginBottom: "30px",
                    }}
                  >
                    {DBFields.map((field, index) => (
                      <Item sx={{ backgroundColor: "#f1f1f1;" }} key={index}>
                        {field.displayName}
                      </Item>
                    ))}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Stack spacing={5}>
                    {DBFields.map((field, index) => (
                      <Select
                        key={index}
                        value={selectedValues[index]?.Column || ""}
                        onChange={(event) =>
                          handleSelectChange(
                            field.fieldName,
                            event.target.value,
                            index
                          )
                        }
                        sx={{
                          width: 180,
                          height: 35,
                          borderRadius: "8px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#333",
                          },
                        }}
                      >
                        {columns.map((item) => (
                          <MenuItem key={item} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    ))}
                  </Stack>
                </Box>
              </Box>
            </div>
          )}
        </div>
        {selectedTemplate.templateName && (
          <>
            {warningMessage && (
              <p style={{ color: "#ab1368", textAlign: "center" }}>
                {warningMessage}
              </p>
            )}
            <div className="confirm-reset-container">
              <Button
                type="submit"
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  backgroundColor: "#ab1368",
                  "&:hover": {
                    backgroundColor: "#8d0e56",
                  },
                }}
                onClick={handleConfirmClick}
                disabled={!isFormValid}
              >
                CONFIRM
              </Button>
              {/* <Button
                type="submit"
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  backgroundColor: "#ab1368",
                  "&:hover": {
                    backgroundColor: "#8d0e56",
                  },
                }}
                onClick={handleSelectReset}
              >
                RESET
              </Button> */}
            </div>
          </>
        )}
      </div>
      {/* Ambiguous Header Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Ambiguous Header Detected
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            The file you have uploaded has an ambiguous header value:{" "}
            <strong>{ambiguousHeader}</strong>. Please correct the header value
            and re-upload the file.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {/* Dialog for missing required fields */}
      <Dialog
        open={openMapCheckDialog}
        onClose={handleMapCheckDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Mandatory Fields Missing
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            The following mandatory fields need to be mapped:{" "}
            <strong>{missingFields.join(", ")}</strong>. Please assign a column
            to these fields before submitting.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleMapCheckDialogClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MatchNew;
